import React from "react";
import { useSelector } from "react-redux";
import styles from './AddressesRegistrationForm.module.scss';
import useCurrentAddress from "../../../hooks/useCurrentAddress";
import { ReactComponent as HomeAddres} from '../../../../../resource/HomeAddres.svg'
import { generateAddress } from "../../../utils/generateAddress";
import BtnRegistration from "../../common/BtnRegistration/BtnRegistration";
import TypeIcon from "../HouseRegistrationTypeManager/components/TypeIcon/TypeIcon";

export const AddressesList = ({ company, address, house }) => {
  return (
    <div className={styles.addressList}>
    <div style={{display: 'flex', gap: '10px'}}>
      <HomeAddres />
      <div>
        <div className={styles.address}>{address}</div>
        <div className={styles.company}>{company ? `УК "${company?.serviceCompanyName}"` : ''}</div>
      </div>
    </div>
    {house && <TypeIcon type={house?.registrationType}/>}
  </div>
  )
}

const AddressesRegistrationForm = ({ housesData, chengeHistory }) => {
  const address = useCurrentAddress();
  const company = useSelector((state) => state.housingStockStore.currentHouse);

  return (
    <div className={styles.conteiner}>
    <div className={styles.header}>
      {housesData ? 
      <>
         <h3 className={styles.title}>Адреса</h3>
        <BtnRegistration title="Изменить адреса" text="Изменить" onClick={chengeHistory} />
      </>:
        <h3 className={styles.title}>Адрес</h3>
      }
    </div>
    {housesData ?
      <div className={styles.lists}>
        {housesData?.map((house) => <AddressesList house={house} houseTypeAccess={house.houseTypeAccess} key={house.houseId} address={generateAddress(house)} company={house} />)}
      </div>  :
    <AddressesList address={address} company={company} />}
</div>
  )
}

export default AddressesRegistrationForm;